"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zrxBuildTrade = void 0;
const rax = __importStar(require("retry-axios"));
const __1 = require("../../..");
const erc20Allowance_abi_1 = require("../utils/abi/erc20Allowance-abi");
const applyAxiosRetry_1 = require("../utils/applyAxiosRetry");
const bignumber_1 = require("../utils/bignumber");
const constants_1 = require("../utils/constants");
const helpers_1 = require("../utils/helpers/helpers");
const zrxService_1 = require("../utils/zrxService");
async function zrxBuildTrade({ adapterManager, web3 }, input) {
    var _a, _b, _c;
    const { sellAsset, buyAsset, sellAmount, slippage, sellAssetAccountId, buyAssetAccountId, wallet } = input;
    try {
        const buyToken = buyAsset.tokenId || buyAsset.symbol;
        const sellToken = sellAsset.tokenId || sellAsset.symbol;
        if (buyAsset.chainId !== 'eip155:1') {
            throw new __1.SwapError('[ZrxBuildTrade] - buyAsset must be on chainId eip155:1', {
                code: __1.SwapErrorTypes.VALIDATION_FAILED,
                details: { chainId: sellAsset.chainId }
            });
        }
        const adapter = await adapterManager.byChainId(buyAsset.chainId);
        const bip44Params = adapter.buildBIP44Params({ accountNumber: Number(buyAssetAccountId) });
        const receiveAddress = await adapter.getAddress({ wallet, bip44Params });
        const slippagePercentage = slippage ? (0, bignumber_1.bnOrZero)(slippage).div(100).toString() : constants_1.DEFAULT_SLIPPAGE;
        /**
         * /swap/v1/quote
         * params: {
         *   sellToken: contract address (or symbol) of token to sell
         *   buyToken: contractAddress (or symbol) of token to buy
         *   sellAmount?: integer string value of the smallest increment of the sell token
         * }
         */
        const zrxRetry = (0, applyAxiosRetry_1.applyAxiosRetry)(zrxService_1.zrxService, {
            statusCodesToRetry: [[400, 400]],
            shouldRetry: (err) => {
                var _a, _b, _c, _d;
                const cfg = rax.getConfig(err);
                const retryAttempt = (_a = cfg === null || cfg === void 0 ? void 0 : cfg.currentRetryAttempt) !== null && _a !== void 0 ? _a : 0;
                const retry = (_b = cfg === null || cfg === void 0 ? void 0 : cfg.retry) !== null && _b !== void 0 ? _b : 3;
                // ensure max retries is always respected
                if (retryAttempt >= retry)
                    return false;
                // retry if 0x returns error code 111 Gas estimation failed
                if (((_d = (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.code) === 111)
                    return true;
                // Handle the request based on your other config options, e.g. `statusCodesToRetry`
                return rax.shouldRetryRequest(err);
            }
        });
        const quoteResponse = await zrxRetry.get('/swap/v1/quote', {
            params: {
                buyToken,
                sellToken,
                sellAmount: (0, helpers_1.normalizeAmount)(sellAmount === null || sellAmount === void 0 ? void 0 : sellAmount.toString()),
                takerAddress: receiveAddress,
                slippagePercentage,
                skipValidation: false,
                affiliateAddress: constants_1.AFFILIATE_ADDRESS
            }
        });
        const { data } = quoteResponse;
        const estimatedGas = (0, bignumber_1.bnOrZero)(data.gas || 0);
        const trade = {
            sellAsset,
            buyAsset,
            success: true,
            statusReason: '',
            sellAssetAccountId,
            receiveAddress,
            rate: data.price,
            depositAddress: data.to,
            feeData: {
                fee: (0, bignumber_1.bnOrZero)(estimatedGas).multipliedBy((0, bignumber_1.bnOrZero)(data.gasPrice)).toString(),
                chainSpecific: {
                    estimatedGas: estimatedGas.toString(),
                    gasPrice: data.gasPrice
                }
            },
            txData: data.data,
            sellAmount: data.sellAmount,
            buyAmount: data.buyAmount,
            allowanceContract: data.allowanceTarget,
            sources: ((_a = data.sources) === null || _a === void 0 ? void 0 : _a.filter((s) => parseFloat(s.proportion) > 0)) || constants_1.DEFAULT_SOURCE
        };
        const allowanceRequired = await (0, helpers_1.getAllowanceRequired)({
            sellAsset,
            allowanceContract: data.allowanceTarget,
            receiveAddress,
            sellAmount: data.sellAmount,
            web3,
            erc20AllowanceAbi: erc20Allowance_abi_1.erc20AllowanceAbi
        });
        if (allowanceRequired) {
            trade.feeData = {
                fee: ((_b = trade.feeData) === null || _b === void 0 ? void 0 : _b.fee) || '0',
                chainSpecific: {
                    ...(_c = trade.feeData) === null || _c === void 0 ? void 0 : _c.chainSpecific,
                    approvalFee: (0, bignumber_1.bnOrZero)(constants_1.APPROVAL_GAS_LIMIT).multipliedBy((0, bignumber_1.bnOrZero)(data.gasPrice)).toString()
                }
            };
        }
        return trade;
    }
    catch (e) {
        if (e instanceof __1.SwapError)
            throw e;
        throw new __1.SwapError('[ZrxBuildTrade]', {
            code: __1.SwapErrorTypes.BUILD_TRADE_FAILED
        });
    }
}
exports.zrxBuildTrade = zrxBuildTrade;
